export const GLOBALS = {
  isAuth: false,
  token: null
}